module.exports = __webpack_public_path__ + "img/2.76a9bdd6.jpg";